import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { SharedModule } from 'src/app/shared/shared.module';
import { ActuLivresRoutingModule } from './actu-livres-routingmodule';

@NgModule({
  imports: [
    CommonModule,
    ActuLivresRoutingModule,
    IonicModule,
    FormsModule,
    SharedModule,
  ],
  declarations: [],
  providers: []
})
export class ActuLivresModule { }
